import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useToast } from "../context/toast-context";
import { CloverService } from "../services/clover-service";
import DivixLogo from "../assets/img/logos/divixNegro.png";

export function CloverAuth() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showToast } = useToast();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    setError(null);

    const handleAuth = async () => {
      const code = searchParams.get("code");
      const client_id = searchParams.get("client_id");
      const merchant_id = searchParams.get("merchant_id");
      const employee_id = searchParams.get("employee_id");

      if (!code || !client_id || !merchant_id || !employee_id) {
        setError(t("clover.auth.missing-params"));
        setIsLoading(false);
        return;
      }

      try {
        const cloverService = new CloverService();
        await cloverService.authenticate(
          {
            code,
            client_id,
            merchant_id,
            employee_id,
          },
          () => {
            showToast(t("clover.auth.success"), "success");
            setIsSuccess(true);
            setIsLoading(false);
          },
          (errorMessage: string) => {
            setError(errorMessage);
            setIsLoading(false);
          }
        );
      } catch (err) {
        setError(t("clover.auth.error"));
        setIsLoading(false);
      }
    };

    handleAuth();
  }, [searchParams, navigate, showToast, t]);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4">
      <img 
        src={DivixLogo} 
        alt="Divix Logo" 
        width={80}
        height={80}
        className="mb-8"
      />
      
      {isLoading && (
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-gray-600 text-lg font-light">
            {t("clover.auth.loading")}
          </p>
        </div>
      )}

      {error && !isSuccess && (
        <div className="flex flex-col items-center gap-4">
          <p className="text-red-500 text-lg font-light text-center max-w-md">
            {error}
          </p>
          <button
            onClick={() => navigate("/")}
            className="mt-4 px-6 py-2 bg-primary text-white rounded-full font-light hover:bg-opacity-90 transition-colors"
          >
            {t("common.back-to-home")}
          </button>
        </div>
      )}

      {isSuccess && !error && (
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
            <svg
              className="w-8 h-8 text-green-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <p className="text-green-500 text-lg font-light text-center max-w-md">
          {t("clover.auth.success-message")}
          
          </p>
          {/*<p className="text-green-500 text-lg font-light text-center max-w-md">
          Recuerda revisar tu casilla de email para aceptar la adhesión al débito automático
          </p>*/}
          <button
            onClick={() => navigate("/")}
            className="mt-4 px-6 py-2 bg-primary text-white rounded-full font-light hover:bg-opacity-90 transition-colors"
          >
            Ir a la página principal
          </button>
        </div>
      )}
    </div>
  );
} 